<template>
  <div class="web">
    <div class="pc-box">
      <!-- 头部导航 -->
      <div class="pc-header">
        <div class="pc-header-auto">
          <div class="header-left">
            <span class="page-indicator">场馆详情</span>
          </div>
          <div class="header-right" v-if="userInfo && userInfo.fullName">
            <a-icon type="user" style="margin-right: 8px" />
            <span>{{ userInfo.fullName }}</span>
          </div>
        </div>
      </div>

      <!-- 内容主体 -->
      <div class="pc-content-wrapper">
        <div class="pc-content-inner">
          <!-- 面包屑 -->
          <a-breadcrumb class="custom-breadcrumb">
            <a-breadcrumb-item>场馆详情</a-breadcrumb-item>
          </a-breadcrumb>

          <!-- 场馆核心展示区 -->
          <div class="venue-hero-card">
            <a-row :gutter="48">
              <a-col :span="11">
                <div class="gallery-wrapper">
                  <a-carousel arrows autoplay>
                    <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px; z-index: 1">
                      <a-icon type="left-circle" />
                    </div>
                    <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                      <a-icon type="right-circle" />
                    </div>
                    <div v-for="(item, index) in (record.picUrls || '').split(',')" :key="index" class="carousel-item">
                      <img :src="fileDisplayPrefix + item" class="hero-img" />
                    </div>
                  </a-carousel>
                </div>
              </a-col>
              <a-col :span="13">
                <div class="venue-essentials">
                  <h1 class="main-title">
                    {{ record.name }}
                    <a-button type="primary" @click="$router.push('/orderIndex-pc')"   class="booking-btn">
                      预约记录
                    </a-button>
                  </h1>
                  <div class="meta-info">
                    <div class="meta-row">
                      <a-icon type="environment" theme="twoTone" two-tone-color="#883032" />
                      <span class="meta-label">地理位置</span>
                      <span class="meta-value">{{ record.address }}</span>
                    </div>
                  </div>
                  <a-divider />
                  <div class="venue-intro-section">
                    <h3 class="sub-heading">场馆介绍</h3>
                    <div class="rich-content" v-html="record.remark"></div>
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>

          <!-- 预约类型列表 -->
          <div class="selection-header">
            <span class="selection-title">可预约场地类型</span>
            <span class="selection-subtitle">请选择您感兴趣的场地类型进行预约</span>
          </div>

          <div class="sport-type-grid">
            <a-row :gutter="[24, 24]">
              <a-col :span="12" v-for="(item, index) in (record.sportList || [])" :key="index">
                <div class="sport-entry-card">
                  <div class="entry-image">
                    <img :src="fileDisplayPrefix + item.picUrl" />
                  </div>
                  <div class="entry-detail">
                    <div class="entry-top">
                      <h4 class="sport-label">{{ getDictName(sportTypeList, item.sportType) }}</h4>
                      <a-tag color="blue">场地数量: {{ item.count || 0 }}</a-tag>
                    </div>
                    <div class="entry-price-box">
                      <span class="price-prefix"></span>
                      <span class="price-amount">
<!--                        <small>￥</small>-->
<!--                        0.00-->
<!--                        <span class="price-unit">/{{ getDictName(chargeTypeOptions, item.chargeType) }}</span>-->
                      </span>
                    </div>
                    <div class="entry-footer">
                      <a-button type="primary" size="large" block class="booking-btn" @click="toReserve(item)">
                        立即预约
                      </a-button>
                    </div>
                  </div>
                </div>
              </a-col>
            </a-row>

            <div v-if="!(record.sportList && record.sportList.length)" class="empty-placeholder">
              <a-empty description="该场馆暂无开放中的预约类型" />
            </div>
          </div>
        </div>
      </div>

      <!-- 页脚 -->
      <div class="pc-footer">
        <div class="footer-content">
          <p>智慧能源创新学院 场馆预约系统</p>
          <p class="copyright">Copyright © www.senergy.sjtu.edu.cn. All Rights Reserved</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FILE_DISPLAY_PREFIX } from '@/api/upload'
import { getDictByType } from '@/api/common'
import { getDictName } from '@/utils/common'
import { getDetailBySetting } from '@/api/venue/venue'
import { getUserInfo } from '@/api/my/my'
import { Card, Row, Col, Carousel, Icon, Divider, Tag, Button, Breadcrumb, Empty } from 'ant-design-vue'

export default {
  name: 'VenueDetailPc',
  components: {
    'a-card': Card,
    'a-row': Row,
    'a-col': Col,
    'a-carousel': Carousel,
    'a-icon': Icon,
    'a-divider': Divider,
    'a-tag': Tag,
    'a-button': Button,
    'a-breadcrumb': Breadcrumb,
    'a-breadcrumb-item': Breadcrumb.Item,
    'a-empty': Empty
  },
  data() {
    return {
      fileDisplayPrefix: FILE_DISPLAY_PREFIX,
      id: '',
      record: {},
      chargeTypeOptions: [],
      sportTypeList: [],
      getDictName,
      userInfo: {}
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.getDict()
      this.getDetail()
      this.getUser()
    },
    getUser() {
      getUserInfo().then(res => {
        if (res.code === 10000) {
          this.userInfo = res.result || {}
        }
      })
    },
    getDetail() {
      getDetailBySetting().then(res => {
        if (res.code === 10000) {
          this.record = res.result
        }
      })
    },
    getDict() {
      getDictByType('charge_type').then(res => {
        if (res.code === 10000) {
          this.chargeTypeOptions = res.result.map(item => ({
            label: item.dictKey,
            value: item.dictValue
          }))
        }
      })
      getDictByType('sport_type').then(res => {
        if (res.result) {
          this.sportTypeList = res.result.map(item => ({
            label: item.dictKey,
            value: item.dictValue
          }))
        }
      })
    },
    toReserve(item) {
      this.$store.commit('setVenueInfo', item)
      this.$router.push({
        path: '/venueReserve-pc',
        query: { venueId: item.venueId, sportType: item.sportType }
      })
    }
  }
}
</script>

<style scoped>
.web {
  background: #f4f7f9;
  min-height: 100vh;
}
.pc-header {
  background: #fff;
  height: 72px;
  display: flex;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  position: sticky;
  top: 0;
  z-index: 100;
}
.pc-header-auto {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.brand-logo {
  height: 36px;
  cursor: pointer;
  margin-right: 24px;
}
.page-indicator {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  border-left: 2px solid #e8e8e8;
  padding-left: 24px;
}
.header-right {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}
.pc-content-wrapper {
  padding: 32px 0 64px;
}
.pc-content-inner {
  width: 1200px;
  margin: 0 auto;
}
.custom-breadcrumb {
  margin-bottom: 24px;
}
.venue-hero-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.03);
  margin-bottom: 48px;
}
.gallery-wrapper {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
}
.carousel-item {
  height: 420px;
  background: #fafafa;
}
.hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-title {
  font-size: 36px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.booking-list-btn {
  font-size: 14px;
  height: 36px;
}
.meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  color: #4a4a4a;
}
.meta-label {
  color: #999;
  font-weight: 500;
}
.meta-value {
  color: #333;
}
.sub-heading {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #333;
}
.rich-content {
  line-height: 1.8;
  color: #666;
  font-size: 15px;
}
.selection-header {
  margin-bottom: 32px;
}
.selection-title {
  font-size: 24px;
  font-weight: 800;
  color: #1a1a1a;
  margin-right: 16px;
}
.selection-subtitle {
  color: #999;
  font-size: 15px;
}
.sport-entry-card {
  display: flex;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  height: 200px;
  border: 1px solid #eef2f6;
  transition: all 0.3s;
}
.sport-entry-card:hover {
  box-shadow: 0 12px 32px rgba(136, 48, 50, 0.12);
  transform: translateY(-6px);
  border-color: #883032;
}
.entry-image {
  width: 260px;
}
.entry-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.entry-detail {
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
}
.entry-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.sport-label {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}
.entry-price-box {
  margin-bottom: 20px;
}
.price-prefix {
  color: #999;
  margin-right: 8px;
}
.price-amount {
  color: #883032;
  font-size: 28px;
  font-weight: 800;
}
.price-unit {
  font-size: 14px;
  font-weight: normal;
  color: #666;
  margin-left: 4px;
}
.booking-btn {
  background: #883032;
  border-color: #883032;
  height: 48px;
  font-weight: 600;
  border-radius: 8px;
}
.booking-btn:hover {
  background: #a03d3f;
  border-color: #a03d3f;
}
.empty-placeholder {
  padding: 100px 0;
  background: #fff;
  border-radius: 16px;
}
.pc-footer {
  background: #fff;
  padding: 48px 0;
  border-top: 1px solid #e8e8e8;
}
.footer-content {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  color: #666;
}
.copyright {
  color: #999;
  font-size: 13px;
  margin-top: 8px;
}

/* Custom Slick Arrows */
.custom-slick-arrow {
  width: 40px;
  height: 40px;
  font-size: 40px;
  color: #fff;
  opacity: 0.6;
  transition: all 0.3s;
}
.custom-slick-arrow:hover {
  opacity: 1;
  color: #883032;
}
</style>
